<template>
  <div
    v-if="visible"
    class="position-fixed bottom-0 start-50 translate-middle-x mb-3 col-12 col-sm-10 col-md-7 col-lg-5"
    style="z-index:1055;"
  >
    <div class="card shadow-lg mx-3 mx-md-0">
      <div class="card-body d-flex align-items-center gap-2 p-2 p-md-3">

        <img
          src="/web-app-manifest-512x512.png"
          width="40"
          height="40"
          class="rounded"
        />

        <div class="flex-grow-1">
          <div class="fw-bold d-none d-sm-block">Installer My Nemo</div>
          <small class="text-muted d-none d-sm-block">Accès rapide depuis votre écran d'accueil</small>
          <small class="text-muted d-block d-sm-none text-center">Accès rapide depuis votre écran d'accueil</small>
        </div>

        <button
          v-if="!showIOSInstructions"
          class="btn btn-primary text-nowrap"
          @click="install"
        ><span class="fa-stack" style="font-size: 0.6em;">
          <i class="fa-regular fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-plus fa-stack-1x"></i>
        </span> Installer
        </button>

        <button
          class="btn-close"
          @click="close"
        ></button>

      </div>

      <div
        v-if="showIOSInstructions"
        class="card-footer text-center text-muted small py-2"
      >
        Appuyez sur les icones
        <span class="fa-stack" style="font-size: 0.6em;">
          <i class="fa-regular fa-circle fa-stack-2x"></i>
          <i class="fa-solid fa-ellipsis fa-stack-1x"></i>
        </span>
        <br><i class="fa-solid fa-arrow-up-from-bracket"></i><strong> Partager</strong>,
        <br><i class="fa-regular fa-square-plus"></i><strong> Sur l'écran d'accueil</strong>,
        <br>et enfin sur <strong>Ajouter</strong>.
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { usePwaInstall } from "@/compositions/usePwaInstall"

const { visible, install, close, showIOSInstructions } = usePwaInstall()
</script>
